import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { RadnaKnjizica } from './radna-knjizica';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-radna-knjizica-update',
  templateUrl: './radna-knjizica-update.component.html'
})
export class RadnaKnjizicaUpdateComponent
extends BaseUpdateComponent<RadnaKnjizica>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
   }

  ngOnInit() {

    super.ngOnInit();
    this.addValidatorToFc('OsobaID', Validators.required, 'required', 'RADNAKNJIZICA.OSOBA.VALIDATION.REQUIRED');
    this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'RADNAKNJIZICA.ORGJED.VALIDATION.REQUIRED');
    // tslint:disable-next-line:max-line-length
    // this.addValidatorToFc('naziv_i_sediste_poslodavca', Validators.required, 'required', 'RADNAKNJIZICA.NAZIVISEDISTEPOSLODAVCA.VALIDATION.REQUIRED');
    this.addValidatorToFc('staz_meseci', Validators.required, 'required', 'RADNAKNJIZICA.STAZMESECI.VALIDATION.REQUIRED');
    this.addValidatorToFc('staz_godina', Validators.required, 'required', 'RADNAKNJIZICA.STAZGODINA.VALIDATION.REQUIRED');
    this.addValidatorToFc('staz_dana', Validators.required, 'required', 'RADNAKNJIZICA.STAZDANA.VALIDATION.REQUIRED');
    this.addValidatorToFc('od_datuma', Validators.required, 'required', 'RADNAKNJIZICA.ODDATUMA.VALIDATION.REQUIRED');
    this.addValidatorToFc('do_datuma', Validators.required, 'required', 'RADNAKNJIZICA.DODATUMA.VALIDATION.REQUIRED');
    this.addValidatorToFc('prc_ang', Validators.required, 'required', 'RADNAKNJIZICA.PRCANG.VALIDATION.REQUIRED');
    this.addValidatorToFc('ned_fond_sati', Validators.required, 'required', 'RADNAKNJIZICA.NEDFONDSATI.VALIDATION.REQUIRED');
  }

  onOdDatumaChange(){
    this.preracunaj_staz();
    this.koriguj_staz();
  }

  onDoDatumaChange(){
    this.preracunaj_staz();    
    this.koriguj_staz();
  }

  prc_angChanged(){
    this.preracunaj_staz();    
    this.koriguj_staz();
  }

  preracunaj_staz(){
    if (this.baseFormGroup){
      let OdDatumaTmp:NgbDate=this.baseFormGroup.get("od_datuma").value as NgbDate;
      let DoDatumaTmp:NgbDate=this.baseFormGroup.get("do_datuma").value as NgbDate;
      
      let PrcAng:number=this.baseFormGroup.get("prc_ang").value;
      var StazGodina:number=0;
      var StazMeseci:number=0;
      var StazDana:number=0;

      // Da ponudimo koliki je staž za ako nije unet i ako je angažovanje 100%
      if (PrcAng
        && PrcAng==100 
        && (
          !this.baseFormGroup.get("staz_godina").value
          || !this.baseFormGroup.get("staz_meseci").value
          || !this.baseFormGroup.get("staz_dana").value
          || (
            this.baseFormGroup.get("staz_godina").value==0
            && this.baseFormGroup.get("staz_meseci").value==0
            && this.baseFormGroup.get("staz_dana").value==0
          )
        ) 
      ){
        // Iz nekog razloga ova konverzija u NgbDate ne radi u potpunosti
        let OdDatuma:NgbDate=new NgbDate(OdDatumaTmp.year, OdDatumaTmp.month, OdDatumaTmp.day);
        let DoDatuma:NgbDate=new NgbDate(DoDatumaTmp.year, DoDatumaTmp.month, DoDatumaTmp.day);

        if (DoDatuma.after(OdDatuma) ){
          StazGodina=DoDatuma.year-OdDatuma.year
          if (StazGodina>0 
          && !(DoDatuma.month>OdDatuma.month || (DoDatuma.month>=OdDatuma.month && DoDatuma.day>OdDatuma.day))){
            StazGodina=StazGodina-1
            StazMeseci=12;
          }
          
          StazMeseci=StazMeseci+DoDatuma.month-OdDatuma.month;
          if (StazMeseci>0 && OdDatuma.day>DoDatuma.day){
            StazMeseci=StazMeseci-1;
            StazDana=30;
          }

          StazDana=StazDana+DoDatuma.day-OdDatuma.day+1;

        } else {
            if (DoDatuma.equals(OdDatuma)){
              StazDana=1;
            }
        }
        
        this.baseFormGroup.get("staz_godina").patchValue(StazGodina);
        this.baseFormGroup.get("staz_meseci").patchValue(StazMeseci);
        this.baseFormGroup.get("staz_dana").patchValue(StazDana);

      }
    }
  }

  koriguj_staz(){
    var StazGodina:number= this.baseFormGroup.get("staz_godina").value;
    var StazMeseci:number=this.baseFormGroup.get("staz_meseci").value;
    var StazDana:number=this.baseFormGroup.get("staz_dana").value;

    if (StazGodina!=null
     && StazMeseci!=null
     && StazDana!=null) {

      while (StazDana>29) {
        StazDana=StazDana-30;
        StazMeseci=StazMeseci+1;
      }

      while (StazMeseci>11) {
        StazMeseci=StazMeseci-12;
        StazGodina=StazGodina+1;
      }

      let OdDatuma:NgbDate=this.baseFormGroup.get("od_datuma").value as NgbDate;
      let DoDatuma:NgbDate=this.baseFormGroup.get("do_datuma").value as NgbDate;
      if (OdDatuma
      && DoDatuma
      && DoDatuma.month==OdDatuma.month && StazMeseci>0){
        StazDana=0;
      }

      this.baseFormGroup.get("staz_godina").patchValue(StazGodina);
      this.baseFormGroup.get("staz_meseci").patchValue(StazMeseci);
      this.baseFormGroup.get("staz_dana").patchValue(StazDana);
    }
  }

}
